import { CarDetailsDuck } from './../redux/carDetails/carDetails.duck';
import { getSessionIdCookie } from '@utils/Session.utils';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FEATURES_LIST } from 'src/context/featureSwitchApp';
import { DealService } from 'src/services';
import { useCarDetailsDuck } from './useCarDetailsDuck';
import { useExternalCheckout } from './useExternalCheckout';
import { useFeatureSwitchEnabled } from './useFeatureSwitchEnabled';
import UIDuck from 'src/redux/commonDucks/ui.duck';
import { dealStatuses } from '../pages/checkout/my-details';

/**
 * Sets status to basket if it is not already, synchronizes useExternalCheckout, adds dealer fees on STOCK
 */
export const useUpdateDealForBasketToCheckout = () => {
    const { currentDeal } = useCarDetailsDuck();
    const { externalCheckoutEnabled } = useExternalCheckout();
    const dispatch = useDispatch();
    const isDealerFeesEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_DEALER_FEES_ENABLED);

    useEffect(() => {
        if (
            !currentDeal ||
            [
                dealStatuses.redirectedToLoanProvider,
                dealStatuses.financeApproved,
                dealStatuses.financeRejected,
            ].includes(currentDeal?.status) ||
            (currentDeal?.status === 'basket' &&
                currentDeal?.extraFields.useExternalCheckout === externalCheckoutEnabled)
        ) {
            return;
        }
        const fetchDealerFees = currentDeal.fullProductConfiguration.stock && isDealerFeesEnabled;
        dispatch(UIDuck.setLoading(5));
        DealService.updateDealStatus(
            'basket',
            getSessionIdCookie(),
            {
                useExternalCheckout: externalCheckoutEnabled,
            },
            fetchDealerFees ? { fetchDealerFees } : {}
        )
            .then((res) => {
                if (fetchDealerFees && res.data?.deal?.extraFields.dealerFees) {
                    dispatch(CarDetailsDuck.setCurrentCarDetails(res.data.deal.fullProductConfiguration));
                    dispatch(CarDetailsDuck.setCurrentDeal(res.data.deal));
                }
            })
            .finally(() => {
                dispatch(UIDuck.setLoading(-5));
            });
    }, [currentDeal?.status, externalCheckoutEnabled]);
};
